export default __webpack_public_path__ + "static/media/Remolquede SúperLujo4.e638abca.png";